import { Descriptions } from "ant-design-vue";
const { ...other } = Descriptions;
const YwDescriptions = {
	...other,
	name: "YwDescriptions",
};
YwDescriptions.install = function (Vue) {
	Vue.component(YwDescriptions.name, YwDescriptions);
};
export default YwDescriptions;
